export default "__VITE_ASSET__CLOAgm2P__"